$labelSize: 25%;
$contentSize: 75%;

:host {
  display: block;
}

gz-tooltip[class='label'] {
  width: $labelSize;
}

gz-tags-enum-list::part(autoBtn) {
  display: none;
}

.checkbox-security {
  padding-left: $labelSize;
}

gz-text {
  display: inline;
}

.mr-05 {
  margin-right: calc(var(--spacer) / 2);
}

.content {
  width: $contentSize;
}

gz-enum-list[class='rule-tags'] {
  width: 337px;
  margin-left: -8px;
  margin-top: -12px;

  &::part(listGroup) {
    height: auto;
    min-height: 25px;
    max-height: 160px;
    padding: 0 var(--spacer);
  }

  &::part(optionAll) {
    padding: 0 var(--spacer);
  }

  &::part(listOptions) {
    border: 1px solid var(--chart-101-pressed-dividers);
    border-radius: 3px;
    margin: 0 var(--spacer);
  }
}

.checkbox-description {
  padding: 8px 0 8px 26px;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-chips-generator-input {
  width: auto;
  --chip-list-width: 400px;
}

.delete-rule-btn {
  align-self: center;
}

.yara-description {
  padding-left: calc(var(--spacer) * 4 - 5px);
}

#loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  background: var(--chart-304-icon-buttons);
  z-index: 5;

  gz-progress-spinner {
    text-align: center;
    z-index: 4;
  }
}

.rule-configuration-label {
  min-width: 250px;
}

.rule-outcome-container {
  .rule-outcome-label {
    width: auto;
    min-width: 250px;
    max-width: 40%;
    margin-top: 6px;
  }

  .rule-outcome-content {
    flex: 0.7;
  }
}

.info-box {
  margin-left: -10px;
}
